// 🔹 กำหนด Breakpoint
const breakpoints = {
  xs: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const

// 🔸 กำหนด type ของ breakpoint name
type Breakpoint = keyof typeof breakpoints

// 🔹 กำหนด shape ของสิ่งที่ return จาก useWindowSize
interface WindowSize {
  width: Ref<number>
  height: Ref<number>
  breakpoint: ComputedRef<Breakpoint>
  isMobile: ComputedRef<boolean>
  isTablet: ComputedRef<boolean>
  isDesktop: ComputedRef<boolean>
}

export function useWindowSize(): WindowSize {
  const width = ref(0)
  const height = ref(0)

  const updateSize = () => {
    width.value = window.innerWidth
    height.value = window.innerHeight
  }

  onMounted(() => {
    updateSize()
    window.addEventListener('resize', updateSize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateSize)
  })

  const breakpoint = computed<Breakpoint>(() => {
    if (width.value < breakpoints.sm) return 'xs'
    if (width.value < breakpoints.md) return 'sm'
    if (width.value < breakpoints.lg) return 'md'
    if (width.value < breakpoints.xl) return 'lg'
    if (width.value < breakpoints['2xl']) return 'xl'
    return '2xl'
  })

  return {
    width,
    height,
    breakpoint,
    isMobile: computed(() => width.value < breakpoints.md),
    isTablet: computed(() => width.value >= breakpoints.md && width.value < breakpoints.lg),
    isDesktop: computed(() => width.value >= breakpoints.lg),
  }
}
